import { AIGC_TAG_GROUPS } from './aigcTagOptions';
import { BASE_TASK_OPTIONS } from './baseTaskOptions';
import { SCIENCE_CATALOGUE_OPTIONS } from './scienceCatalogueOptions';
import { SKILL_TYPE_OPTIONS } from './skillTypeOptions';
import type { ModelType, OpsPublishOption } from './types';

function walkOptions(options: OpsPublishOption[], map: Map<string, string>) {
  for (const opt of options) {
    map.set(opt.value, opt.label);
    if (opt.children?.length) {
      walkOptions(opt.children, map);
    }
  }
}

/** 构建所有广场标签选项 value -> label 映射（label 随当前语言变化）。 */
export function getOpsTagValueLabelMap(): Map<string, string> {
  const map = new Map<string, string>();
  walkOptions(BASE_TASK_OPTIONS, map);
  walkOptions(SCIENCE_CATALOGUE_OPTIONS, map);
  walkOptions(SKILL_TYPE_OPTIONS, map);
  for (const group of AIGC_TAG_GROUPS) {
    walkOptions(group.options, map);
  }
  return map;
}

/** 将单个 value 映射为当前语言的 label，未命中时回退原 value。 */
export function resolveOpsTagSegmentLabel(value: string): string {
  return getOpsTagValueLabelMap().get(value) ?? value;
}

/** 将路径型 opsTag（如 BASE/SCIENCE）各段 value 映射为 label。 */
export function formatOpsTagPathLabel(path: string): string {
  return path
    .split('/')
    .map((segment) => resolveOpsTagSegmentLabel(segment))
    .join('/');
}

export interface FormatOpsTagDisplayOptions {
  modelType?: ModelType;
  artifactType?: string;
}

/** 将 API 返回的 opsTag value 数组转为当前语言的展示文案。 */
export function formatOpsTagForDisplay(tags: string[] | undefined, options?: FormatOpsTagDisplayOptions): string[] {
  if (!tags?.length) return [];

  const { modelType, artifactType } = options ?? {};

  if (artifactType === 'skills') {
    return tags.map((tag) => resolveOpsTagSegmentLabel(tag));
  }

  switch (modelType) {
    case 'BASE':
      return tags.map((tag) => formatOpsTagPathLabel(tag));
    case 'SCIENCE':
      return tags.map((tag) => formatOpsTagPathLabel(tag));
    case 'AIGC':
      return tags.map((tag) => resolveOpsTagSegmentLabel(tag));
    default:
      return tags.map((tag) => (tag.includes('/') ? formatOpsTagPathLabel(tag) : resolveOpsTagSegmentLabel(tag)));
  }
}
